import Complaints from "../../Complaints/Complaints.jsx";
import { Modal } from "react-bootstrap";
import { useMemo } from "react";
import ShareBlock from "./ShareBlock.jsx";

export function ProposalPopup({
  proposal,
  configuration,
  show,
  onHide,
  sendProposal,
  proposalLiked,
  setProposalLiked
}) {

  let answerButtons = "";
  if (configuration.enableAnswerButtons) {
    answerButtons = (
      <form
        onSubmit={(e) => sendProposal(e)}
        className="d-flex gap-2 align-items-center"
      >
        <input type="hidden" name="proposal" value={proposal.pk} />
        <button
          type="submit"
          name="answer"
          className={`btn fs-6 ${
            proposalLiked === "LIKE" ? "btn-success" : "btn-outline-success"
          }`}
          value="1"
          title={configuration.translations.Yes}
          onClick={() => {
            setProposalLiked("LIKE");
          }}
        >
          <i
            className="fa-regular fa-thumbs-up"
            title={configuration.translations.Yes}
          ></i>
        </button>
        <button
          type="submit"
          name="answer"
          className={`btn  fs-6 ${
            proposalLiked === "DISLIKE" ? "btn-danger" : "btn-outline-danger"
          }`}
          value="0"
          title={configuration.translations.No}
          onClick={() => {
            setProposalLiked("DISLIKE");
          }}
        >
          <i
            className="fa-regular fa-thumbs-down"
            title={configuration.translations.No}
          ></i>
        </button>
      </form>
    );
  }

  const bodyHtml = useMemo(
    () => proposal.body, // solo cambia si llega otra propuesta
    [proposal.pk]
  );

  return (
    <Modal show={show} onHide={onHide} className="modal-lg">
      {/* {imageStyles} */}
      <Modal.Header closeButton className="bg-light">
        <div className="small py-2 px-3 bg-secondary-subtle rounded-pill d-flex align-items-center justify-content-center gap-1 text-uppercase">
          <i className="small icon-proposal"></i>
          {configuration.translations.proposalsTitle}
        </div>
      </Modal.Header>
      <Modal.Title className="px-3 fw-bold fs-2 text-primary font-weight-bold bg-light">
        {proposal.name}
      </Modal.Title>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: bodyHtml }}></div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-100 d-flex align-items-center justify-content-between">
          <a
            href={configuration.homeUrl}
            className="logo"
            title={configuration.branding.name}
          ></a>
          {answerButtons}
          <Complaints id={proposal.pk} csrfToken={configuration.csrfToken} />
        </div>
      </Modal.Footer>
      <Modal.Footer
        className="w-100 d-flex align-items-center justify-content-start"
        style={{ height: "100px" }}
      >
        <ShareBlock
          url={proposal.detail_url}
          text={proposal.name}
          configuration={configuration}
        />
      </Modal.Footer>
    </Modal>
  );
}
